module.exports = __WEBPACK_EXTERNAL_MODULE_33__;


//////////////////
// WEBPACK FOOTER
// external "underscore"
// module id = 33
// module chunks = 0